// extracted by mini-css-extract-plugin
export default {"wrapper":"PropertyProduct_wrapper__wLyLx","infiniteLoader":"PropertyProduct_infiniteLoader__BHKWv","spin":"PropertyProduct_spin__vOxqM"};